var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.12,
    height: 43.767,
    viewBox: "0 0 83.12 43.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42333",
    "data-name": "Group 42333",
    transform: "translate(564.826 -558.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82658",
    "data-name": "Path 82658",
    d: "M-546.9,584.246c.518-1.4.958-2.572,1.383-3.748.44-1.215.82-2.455,1.326-3.642a1.407,1.407,0,0,1,.966-.693,22.883,22.883,0,0,1,2.685-.032c-.52,1.336-.944,2.445-1.383,3.548-1.133,2.849-2.29,5.689-3.4,8.548a1.184,1.184,0,0,1-1.322.91c-2.2-.1-1.732.265-2.486-1.685q-2-5.172-3.972-10.357c-.093-.244-.156-.5-.288-.93,1.121,0,2.127-.049,3.122.037.231.02.5.468.619.771.783,2.05,1.527,4.114,2.288,6.172C-547.247,583.444-547.113,583.733-546.9,584.246Z",
    fill: "#8c92c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82659",
    "data-name": "Path 82659",
    d: "M-562.24,581.374c0-2.251,0-4.5,0-6.754,0-.489.223-.669.711-.707,2.49-.2,2.491-.208,2.493,2.252,0,3.036.029,6.073-.016,9.109-.013.848.207,1.184,1.1,1.141,1.379-.066,2.765.008,4.147-.032.714-.021.944.25.93.948-.041,2.08.157,1.771-1.783,1.781-2.165.011-4.33-.033-6.493.02-.847.021-1.116-.308-1.109-1.094.02-2.221.007-4.442.007-6.663Z",
    fill: "#8c92c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82660",
    "data-name": "Path 82660",
    d: "M-539.013,582.627c0-1.862.018-3.725-.01-5.587-.01-.646.193-.924.874-.911,2.867.056,2.321-.371,2.366,2.284.038,2.283,0,4.566.011,6.849,0,1.174.022,1.183,1.23,1.189,1.021.005,2.043.023,3.063-.007.688-.019.951.242.958.948.016,1.724.044,1.728-1.685,1.73-1.922,0-3.846-.045-5.766.011-.863.025-1.076-.3-1.056-1.1C-538.982,586.232-539.013,584.429-539.013,582.627Z",
    fill: "#8c92c7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42332",
    "data-name": "Group 42332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82661",
    "data-name": "Path 82661",
    d: "M-503.486,561.328a19.369,19.369,0,0,0-19.555,19.342,19.46,19.46,0,0,0,19.461,19.7,19.426,19.426,0,0,0,19.527-19.521A19.343,19.343,0,0,0-503.486,561.328Zm-.03,36.8a17.327,17.327,0,0,1-17.3-17.241,17.4,17.4,0,0,1,16.954-17.323,17.333,17.333,0,0,1,17.6,17.019A17.277,17.277,0,0,1-503.516,598.132Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82662",
    "data-name": "Path 82662",
    d: "M-503.493,558.916a21.712,21.712,0,0,0-21.92,21.68A21.811,21.811,0,0,0-503.6,602.683,21.776,21.776,0,0,0-481.711,580.8,21.683,21.683,0,0,0-503.493,558.916Zm-.421,2.511a19.431,19.431,0,0,1,19.729,19.079,19.368,19.368,0,0,1-19.342,19.664,19.42,19.42,0,0,1-19.391-19.325A19.506,19.506,0,0,1-503.914,561.427Z",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82663",
    "data-name": "Path 82663",
    d: "M-486.261,580.587a17.277,17.277,0,0,1-17.255,17.545,17.327,17.327,0,0,1-17.3-17.241,17.4,17.4,0,0,1,16.954-17.323A17.333,17.333,0,0,1-486.261,580.587Z",
    fill: "#8c92c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82664",
    "data-name": "Path 82664",
    d: "M-505.894,575.476l-2.9,1.073c0-1.248-.017-2.358.013-3.467a.867.867,0,0,1,.294-.654c2.163-1.1,4.112-2.918,6.978-2.086v20.6h-4.38Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 48.298,
    transform: "translate(-564.826 597.912)",
    stroke: "#a1a3ef",
    strokeMiterlimit: 10,
    strokeWidth: 1.732
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 48.298,
    transform: "translate(-564.826 565.543)",
    stroke: "#a1a3ef",
    strokeMiterlimit: 10,
    strokeWidth: 1.732
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1Icon);
export default __webpack_public_path__ + "static/media/Level1Icon.189b37ee892e3c849f2119fc0b0b0610.svg";
export { ForwardRef as ReactComponent };